module.exports = __webpack_public_path__ + "d7ce136b48d6a655846cd21f86bf11c5.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/diamond/images/colourScale/M@2x.png
// module id = 828
// module chunks = 0